import { Grid, Heading, List, Text } from '@raskrask-dk/rr-components'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'
import { ReactElement, ReactNode } from 'react'

type Level = 1 | 2 | 6 | 3 | 4 | 5 | undefined

const Markdowned = ({
    settings,
    markDownText,
}: {
    settings?: { html?: boolean }
    markDownText: string
}): ReactElement => {
    const remarkPlugins = [
        remarkGfm, // Github Markdown (support table)
    ]
    const rehypePlugins = [
        ...(settings?.html ? [rehypeRaw] : []), // HTML
    ]

    const CustomHeader = ({
        children,
        level,
    }: {
        children: ReactNode
        level: Level
    }) => (
        <Heading level={level} primary bold>
            {children}
        </Heading>
    )

    const CustomParagraph = ({ children }: { children: any }) => (
        <Text primary>{children}</Text>
    )

    const CustomeUnOrderedList = ({ children }: { children: any }) => (
        <List listType="ul" listStyleType="disc" items={[children]}>
            {children}
        </List>
    )

    const CustomeOrderedList = ({ children }: { children: any }) => (
        <List listType="ol" type="1" items={[children]}>
            {children}
        </List>
    )

    return (
        <ReactMarkdown
            rehypePlugins={rehypePlugins}
            remarkPlugins={remarkPlugins}
            components={{
                h1: ({ node, ...props }) => (
                    <CustomHeader {...props} level={1} />
                ),
                h2: ({ node, ...props }) => (
                    <CustomHeader {...props} level={2} />
                ),
                h3: ({ node, ...props }) => (
                    <CustomHeader {...props} level={3} />
                ),
                h4: ({ node, ...props }) => (
                    <CustomHeader {...props} level={4} />
                ),
                h5: ({ node, ...props }) => (
                    <CustomHeader {...props} level={5} />
                ),
                h6: ({ node, ...props }) => (
                    <CustomHeader {...props} level={6} />
                ),
                p: ({ node, ...props }) => <CustomParagraph {...props} />,
                ul: ({ node, ...props }) => <CustomeUnOrderedList {...props} />,
                ol: ({ node, ...props }) => <CustomeOrderedList {...props} />,
            }}
        >
            {markDownText}
        </ReactMarkdown>
    )
}

const PackageModalBody = (markDownText: string): ReactElement => (
    <Grid css={{ alignContent: 'start' }}>
        <Markdowned markDownText={markDownText} settings={{ html: true }} />
    </Grid>
)

export default PackageModalBody
